export const createProjectFormStyles = {
  isFirstProjectTitle: {
    fontSize: '24px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#23252F',
    fontFamily: 'Inter, sans-serif !important',
  },

  tooltipContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  tooltip: {
    '& .MuiTooltip-tooltip': {
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '146%',
      fontSize: '12px',
      background: '#23252F',
      color: '#fff',
      boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
      borderRadius: '8px',
      padding: '4px 8px',
    },
    '& .MuiTooltip-tooltipPlacementTop': {
      marginBottom: '6px !important',
    },
  },

  isFirstProjectSubtitle: {
    padding: '4px 0 20px',
    borderBottom: '1px solid rgba(235, 238, 246, 0.42)',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#6E707A',
    fontFamily: 'Inter, sans-serif !important',
  },

  formInputsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  inputsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '20px',
    marginBottom: '24px',
  },

  singleInputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '20px',
    position: 'relative',

    '& .custom-tooltip': {
      position: 'absolute',
      left: '65px',
      top: '2px',
    },
  },

  inputContainer: {
    width: '50%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '20px',
    position: 'relative',

    '& .custom-tooltip': {
      position: 'absolute',
      left: '65px',
      top: '2px',
    },
  },

  googleMapContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '16px 0',
    overflow: 'hidden',
    borderRadius: '12px',
  },
};
